import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';

const HighLightRoutes = {
  id: 'HighLight-group',
  title: 'HighLight Management',
  type: 'group',
  children: [
    {
      id: 'HighLight-list',
      title: 'HighLight List',
      type: 'item',
      url: '/highlight/list',
      icon: OndemandVideoIcon,
      target: false
    }
  ]
};

export default HighLightRoutes;
